import { Typography, Box, Stack, outlinedInputClasses, InputAdornment } from "@mui/material";
import MzDatePicker from "@markaaz/ui/MzDatePicker";
import dayjs from "dayjs";
import BatchSummaryTable from "./BatchSummaryTable";

const sx = {
  root: {
    color: "darkBlue.c100"
  },

  textField: {
    [`.${outlinedInputClasses.root}`]: {
      "input::placeholder": {
        color: "blue.c100",
        opacity: 1
      }
    }
  }
};

export default function BatchSummaryMain({
  loading,
  fromDate,
  toDate,
  reportsData,
  pagination,
  loadData,
  order,
  orderBy,
  onFromDateSelect,
  onToDateSelect,
  onExpand,
  onClearFilter,
  onRequestSort
}) {
  const fromDateDayjs = fromDate ? dayjs(fromDate) : null;
  const toDateDayJs = toDate ? dayjs(toDate) : null;

  return (
    <Box sx={sx.root}>
      <Box>
        <Typography variant="h4">Batch Summary Reports</Typography>
        <Typography variant="body2" mt={4} mb={10} maxWidth={640}>
          For each batch job completed successfully, batch summary reports can be found here.
        </Typography>
      </Box>

      <Box>
        <Stack direction="row" gap={4}>
          <MzDatePicker
            onChange={onFromDateSelect}
            disableFuture
            slotProps={{
              textField: {
                placeholder: "all dates",
                sx: sx.textField,
                InputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="body1" color="blue.c100">
                        From:
                      </Typography>
                    </InputAdornment>
                  )
                }
              },
              actionBar: {
                actions: ["clear"]
              }
            }}
            value={fromDateDayjs}
            maxDate={toDateDayJs}
          />
          <MzDatePicker
            onChange={onToDateSelect}
            disableFuture
            slotProps={{
              textField: {
                placeholder: "all dates",
                sx: sx.textField,
                InputProps: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="body1" color="blue.c100">
                        To:
                      </Typography>
                    </InputAdornment>
                  )
                }
              },
              actionBar: {
                actions: ["clear"]
              }
            }}
            value={toDateDayJs}
            minDate={fromDateDayjs}
          />
        </Stack>

        <Box mt={8}>
          <BatchSummaryTable
            loading={loading}
            loadData={loadData}
            rows={reportsData}
            pagination={pagination}
            order={order}
            orderBy={orderBy}
            onExpand={onExpand}
            onClearFilter={onClearFilter}
            onRequestSort={onRequestSort}
          />
        </Box>
      </Box>
    </Box>
  );
}
